import React from 'react';

import { Paragraph } from '../components/Paragraph';
import { Subtitle } from '../components/Subtitle';

export const Enquiries = () => {
  return (
    <>
      <Subtitle>Enquiries</Subtitle>
      <Paragraph>
        Should you have any enquiries relating to this Privacy Statement, please
        contact us through the chat facilities available on the Site or email
        Glints at{' '}
        <u>
          <a href="mailto: hi@glints.com">hi@glints.com</a>
        </u>{' '}
        or write to us at the following address:
      </Paragraph>
      <Paragraph>
        Glints Pte Ltd
        <br />
        71 Ayer Rajah Crescent, #05-01, Singapore 139951
      </Paragraph>
      <Paragraph>
        Alternatively, you may contact our Data Protection Officer at{' '}
        <u>
          <a href="mailto: dpo@glints.com">dpo@glints.com</a>
        </u>{' '}
        if you have any enquiries or feedback on our personal data protection
        policies and procedures, or if you wish to make any request.
      </Paragraph>
    </>
  );
};
